<!-- @/components/QuizGameRas.vue -->
<template>
  <v-container>
    <QuizLoadScreen :value="loading" :style="styleBackground" />

    <!-- Tela de Configuração da Aula -->
    <v-row v-if="!categorySelected" justify="center" class="cor-branca">
      <v-col cols="12" md="8">
        <h1>Configurar Aula/Treinamento</h1>
        <v-text-field
          v-model="trainingName"
          label="Digite o nome da Aula/Treinamento"
          outlined
          class="mb-4" />
        <v-select
          v-model="selectedCategory"
          :items="categories"
          item-title="title"
          item-value="id"
          label="Escolha um Quiz"
          outlined />
        <v-text-field
          v-model.number="maxParticipants"
          label="Máximo de Participantes"
          outlined
          type="number"
          class="mb-4" />
        <v-btn
          @click="selectCategory"
          :disabled="!selectedCategory || !trainingName || !maxParticipants"
          color="primary"
          class="mt-4">
          Gerar QR Code
        </v-btn>
        <v-btn color="red" class="mt-4" @click="voltar">
          Voltar
        </v-btn>
      </v-col>
    </v-row>

    <!-- QR Code, Link, Gráfico e Lista de Participantes -->
    <v-row v-else justify="center">
      <v-col cols="12" md="8" class="text-center">
        <div v-if="dynamicLink">
          <QuizQrCode :value="dynamicLink" logo="/logo.svg" />
        </div>
        <h2>ESSE QUIZ: {{ trainingName }}</h2>
        <p>Participantes: {{ currentParticipants }} / {{ maxParticipants }}</p>
        <v-col>
          <v-row justify="center"> 
            <v-btn
              @click="liberarQuiz"
              :disabled="currentParticipants < 1"
              color="success"
              size="small"
              class="mt-4">
              Liberar Quiz para todos
            </v-btn>
            <v-btn
              color="secondary"
              @click="updateRankingData"
              size="small"
              class="mt-4">
              Atualizar Dados
            </v-btn>
            <v-btn
              @click="voltar"
              color="red"
              size="small"
              class="mt-4">
              IR PARA INÍCIO
            </v-btn>
          </v-row>
        </v-col>

        <!-- Tabela com lista de participantes -->
        <v-data-table
          class="zebra-table text-center"
          density="compact"
          :headers="tableHeaders"
          :items="participantsForTable"
          v-if="participants.length" />

        <!-- Gráfico: passa os dados filtrados (apenas nome e nota) para o ChartRankingView -->
        <v-col cols="12">
          <div style="width: 400px">
            <ChartRankingView :data="chartData" :refreshKey="refreshKey" />
          </div>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref } from "vue";
import { v4 as uuidv4 } from "uuid";
import QuizLoadScreen from "./QuizLoadScreen.vue";
import QuizQrCode from "./QuizQrCode.vue";
import ChartRankingView from "../components/ChartRankingView.vue";
import { 
  loadPrivateKey, 
  fetchCategories, 
  checkParticipants, 
  liberateQuiz 
} from "../services/googleSheetsSevice";

export default {
  components: {
    QuizLoadScreen,
    QuizQrCode,
    ChartRankingView
  },
  data() {
    return {
      gameLocal: ref(""),
      currentGameId: ref(null),
      refreshKey: ref(0),
      trainingName: "",
      selectedCategory: null,
      categoryName: "",
      maxParticipants: 0,
      currentParticipants: 0,
      dynamicLink: "",
      intervalId: null,
      categories: [],
      participants: [],
      chartData: [],
      loading: false,
      categorySelected: false,
      quizStarted: false,
      tableHeaders: [
        { title: "Aluno", value: "name" },
        { title: "Status", value: "status" },
        { title: "Nota", value: "nota" },
        { title: "Acertos", value: "acertos" },
        { title: "Erros", value: "erros" }
      ]
    };
  },
  computed: {
    styleBackground() {
      return {
        background: `url(/img/back/1.jpg)`,
        backgroundSize: "cover",
        minHeight: "100vh"
      };
    },
    participantsForTable() {
      return this.participants.map(p => ({ ...p }));
    }
  },
  methods: {
    voltar() {
      this.$router.push("/");
    },
    async selectCategory() {
      this.sessionKey = uuidv4();
      this.categorySelected = true;
      this.categoryName = this.categories.find(cat => cat.id === this.selectedCategory).title;
      this.dynamicLink = `${window.location.origin}/quizras/${this.selectedCategory}?key=${this.sessionKey}&limit=${this.maxParticipants}&category=${encodeURIComponent(this.categoryName)}`;
      this.currentGameId = this.sessionKey;
      this.intervalId = setInterval(this.updateParticipants, 5000);
    },
    async updateParticipants() {
      try {
        const { currentParticipants, participants } = await checkParticipants(this.sessionKey);
        this.currentParticipants = currentParticipants;
        this.participants = participants;
        // Cria chartData apenas com os campos "name" e "nota"
        this.chartData = participants.map(item => ({
          name: item.name,
          nota: Number(item.nota.toString().replace(',', '.')) || 0
        }));
        console.log("Dados para o gráfico:", this.chartData);
      } catch (error) {
        console.error("Erro ao buscar participantes:", error);
      }
    },
    async liberarQuiz() {
      try {
        await liberateQuiz(this.sessionKey);
        this.quizStarted = true;
      } catch (error) {
        console.error("Erro ao liberar o quiz:", error);
      }
    },
    updateRankingData() {
      this.refreshKey++; // Incrementa o refreshKey para forçar a atualização do gráfico
    },
    handleBeforeUnload(event) {
      const confirmationMessage = "Atualizar a página irá apagar o quiz atual e iniciar um novo. Deseja continuar?";
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    }
  },
  async created() {
    await loadPrivateKey();
    this.categories = await fetchCategories();
    // Adiciona um listener para interceptar a atualização (refresh) da página
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }
};
</script>

<style scoped>
::v-deep th {
  text-align: center;
  font-weight: bold;
}
</style>
